import { Component, Input } from '@angular/core';
import { FormFieldConfig, FormTemplateGroup, formTemplateGenericSort } from '../../form-template-model';
import { FormTemplateGeneratorService } from '../form-template-generator.service';
import { FormTemplateGroupFormGroup } from './../../form-template-form-group';

@Component({
  selector: 'csi-form-template-group-generator',
  templateUrl: './form-template-group-generator.component.html',
  styleUrls: ['./form-template-group-generator.component.css']
})
export class FormTemplateGroupGeneratorComponent {
  @Input() formTemplateGroup: FormTemplateGroup;
  @Input() formTemplateGroupFormGroup: FormTemplateGroupFormGroup;
  @Input() readOnly: boolean = false;
  @Input() formatForPDF: boolean = false;
  /** When false with formatForPDF, fields stack vertically (used for consent forms). */
  @Input() usePdfGrid: boolean = true;
  /** Consent-only layout hints for nested acknowledgement / date fields. */
  @Input() isConsentForm: boolean = false;
  @Input() supportingFields: { [key: string]: FormFieldConfig };
  @Input() country = null;
  @Input() isPatientView = false;

  sortFields = formTemplateGenericSort;

  constructor(public formTemplateGeneratorService: FormTemplateGeneratorService) {}
}
